import { PDFDocument, PDFArray, PDFName, PDFRawStream, decodePDFRawStream, StandardFonts, rgb, type PDFPage } from "pdf-lib";

/** Removes jsPDF's local footer text rather than merely covering its visible pixels. */
function removeLocalFooterCounters(page: PDFPage): void {
  const contents = page.node.Contents();
  if (!contents) return;
  const entries = contents instanceof PDFArray ? contents.asArray() : [page.node.get(PDFName.of("Contents"))!];
  const replacements = entries.map(entry => {
    const stream = page.doc.context.lookup(entry);
    if (!(stream instanceof PDFRawStream)) return entry;
    const bytes = decodePDFRawStream(stream).decode();
    let text = "";
    for (let offset = 0; offset < bytes.length; offset += 16384)
      text += String.fromCharCode(...bytes.subarray(offset, offset + 16384));
    const cleaned = text.replace(/BT\b[\s\S]*?\bET/g, block => {
      const position = block.match(/([-\d.]+)\s+([-\d.]+)\s+Td\b/);
      if (!position || Number(position[1]) < page.getWidth() / 2 || Number(position[2]) > 60 || Number(position[2]) < 0) return block;
      if (/\(\d+\s*\/\s*\d+\)\s*Tj/.test(block)) return "";
      // The group-address footer combines its date and local counter in one text operation.
      return block.replace(/ · \d+\s*\/\s*\d+(?=\)\s*Tj)/g, "");
    });
    if (cleaned === text) return entry;
    return page.doc.context.register(page.doc.context.flateStream(cleaned));
  });
  page.node.set(PDFName.of("Contents"), page.doc.context.obj(replacements));
}

/** Replaces chapter-local counters after merging, including mixed A4/A3 plan pages. */
export async function addDocumentPageNumbers(document: PDFDocument): Promise<void> {
  const font = await document.embedFont(StandardFonts.Helvetica);
  const pages = document.getPages();
  for (const [index, page] of pages.entries()) {
    removeLocalFooterCounters(page);
    const right = page.getWidth() - 45;
    const text = `${index + 1} / ${pages.length}`;
    page.drawText(text, { x: right - font.widthOfTextAtSize(text, 7), y: 22, size: 7, font, color: rgb(0.345, 0.416, 0.459) });
  }
}
